import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '../Banner';
import styles from './GradientBanner.module.css';

export default function GradientBanner({ className, children, ...rest }) {
  const classNames = [styles.gradient];

  if (className) {
    classNames.push(className);
  }

  return (
    <Banner className={classNames.join(' ')} {...rest}>
      {children}
    </Banner>
  );
}

GradientBanner.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

GradientBanner.defaultProps = {
  className: undefined,
  children: null,
};
